export const dataUrlToFile = async (
  dataUrl: string,
  filename: string,
  mime: string,
) => {
  const response = await fetch(dataUrl);
  const blob = await response.blob();

  return new File([blob], filename, { type: mime });
};
